module.exports = __webpack_public_path__ + "img/excel.37fd3275.svg";